import { PreviewControllerApi } from 'generated/api/apis/PreviewControllerApi'
import { createFionaClient } from '../templates/ClientFactory'

const previewClient = () => {
	const client = new PreviewControllerApi()
	return {
		getLoansOffers: createFionaClient(client.previewControllerGetLoanPreview.bind(client)),
		getSpecialOffers: createFionaClient(client.previewControllerGetSpecialPreview.bind(client)),
		getSavingsOffers: createFionaClient(client.previewControllerGetSavingsPreview.bind(client))
	}
}

type PreviewClient = ReturnType<typeof previewClient>
let previewClientInstance: PreviewClient
export const getPreviewClient = (rebuild = false) => {
	if (rebuild || !previewClientInstance) {
		previewClientInstance = previewClient()
	}
	return previewClientInstance
}
